import clientData from '@/services/clientData'

export default function buildUrl(path) {
  const protocol = window.location.protocol;
  const domain = clientData('domain.app_domain');
  return `${protocol}//${domain}${path}`;
}